import React from 'react'
import { Select } from 'components/select'

import { FilterOptions } from './filterOptions'
import { LogicOptions } from './logicOptions'

export const EnumFilter = ({ localize, column, update, classes, availableColumns }) => {
  const handleOnChange = React.useCallback((value) => update({ value }), [update])
  const enumeration = availableColumns.find(x => x.id === column.id).enum
  return (
    <div>
      <FilterOptions localize={localize} classes={classes} column={column} update={update}  />
      <Select
        isMulti
        value={column.value}
        onChange={handleOnChange}
        enum={enumeration}
        />
      <LogicOptions localize={localize} classes={classes} column={column} update={update} />
    </div>
  )
}